import { wrapper } from "../../types";
export const defaultProps = wrapper;
